import { ButtonBase, styled } from '@mui/material';
import DESIGN_COLORS from 'shared/_ui/design-colors';

export const PageSectionHeader = styled('div', { name: 'PageSectionHeader' })(({ theme }) => ({
	display: 'grid',
	gridTemplateColumns: '1fr auto 1fr',
	alignItems: 'center',
	margin: theme.spacing(3, 0, 3.5),
}));

export const PageSectionHeading = styled('h2', { name: 'PageSectionHeading' })({
	gridColumn: 2,
	justifySelf: 'center',
	minWidth: 0,
	margin: 0,
	fontSize: 'inherit',
});

export const PageSectionToggle = styled(ButtonBase, { name: 'PageSectionToggle' })(({ theme }) => ({
	gap: theme.spacing(2.5),
	maxWidth: '100%',
	padding: theme.spacing(1.5, 3.5),
	borderRadius: theme.spacing(2.5),
	'&:hover': { backgroundColor: DESIGN_COLORS.borderSoft },
	'& .MuiSvgIcon-root': {
		flexShrink: 0,
		fontSize: '1.1875rem',
		color: DESIGN_COLORS.faint,
		transition: theme.transitions.create('transform', { duration: 200 }),
	},
	'&[aria-expanded="false"] .MuiSvgIcon-root': { transform: 'rotate(-90deg)' },
}));

export const PageSectionActions = styled('div', { name: 'PageSectionActions' })(({ theme }) => ({
	gridColumn: 3,
	justifySelf: 'end',
	display: 'flex',
	alignItems: 'center',
	gap: theme.spacing(1),
}));
